import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DataService } from '../../app/configure/service/deviceservice';
function useDomainParam() {
    const effectRan = useRef(false);
    const [searchParams] = useSearchParams();
    const dataService = new DataService();
    const domainParam = searchParams.get('domain');
    const previousDomain = dataService.getDomain();
    const domain = domainParam || previousDomain || location.hostname;
    const [isDomainAvailable, setIsDomainAvailable] = useState(false);
    // const rootDomain = domain.match(
    //   /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/
    // )[1];
    useEffect(() => {
        if (!effectRan.current) {
            // TODO : Remove this later
            console.log('useDomainParam:: Domain:', domain);
            // Domain switch (debug-only): an explicit ?domain= that differs from the
            // domain we previously cached. The device cache is namespaced by hostname
            // (see CacheService), NOT by this param, so without this the old domain's
            // token / cAuth token / "registered" flag / NATS tokens get replayed
            // against the new domain, which rejects them (Context Generation Failed).
            // Reset just those per-domain credentials and reload so the store
            // re-initializes and re-runs register -> context cleanly for the new
            // domain (the new URL's token is re-applied by useTokenNavigation).
            // Guarded on `previousDomain` so first-load (nothing cached yet) and
            // no-param production loads are never affected.
            if (domainParam && previousDomain && domainParam !== previousDomain) {
                console.log('useDomainParam:: domain changed', previousDomain, '->', domainParam, '- resetting device identity and reloading');
                dataService.setDomain(domainParam);
                dataService.removeDeviceToken();
                dataService.removeCAuthToken();
                dataService.setRegistered(false);
                dataService.removeNATSJwtToken();
                dataService.removeNATSRefreshToken();
                window.location.reload();
                return;
            }
            dataService.setDomain(domain);
            setIsDomainAvailable(true);
        }
        return () => {
            effectRan.current = true;
        };
    }, [domain]);
    return isDomainAvailable;
}
export default useDomainParam;
